import {
    ICustoPrevistoVGVPayload,
    IListagemDeCustosPrevisto,
} from "../../../Interfaces/AssistenciaTecnica/CustoPrevistoRelatorioBI/CustoPrevistoRelatorioBI";
import {
    AtualizacaoDeCustoPrevistoService,
    CadastroDeCustoPrevistoService,
    getDeCustoPrevistoService,
    ListagemDeCustosPrevistoService,
    RemocaoDeCustosPrevistoService,
} from "../../../Services/AssistenciaTecnica/CustoPrevistoRelatorioBI/CustoPrevistoRelatorioBIService";
import { Controller } from "../../Controller";

export async function ListagemDeCustosPrevistoController(
    requestBody: ICustoPrevistoVGVPayload
) {
    return Controller(ListagemDeCustosPrevistoService(requestBody));
}

export async function getDeCustoPrevistoController(ID_CUSTO: number) {
    return Controller(getDeCustoPrevistoService(ID_CUSTO));
}

export async function CadastroDeCustoPrevistoController(
    requestBody: IListagemDeCustosPrevisto
) {
    return Controller(CadastroDeCustoPrevistoService(requestBody));
}

export async function AtualizacaoDeCustoPrevistoController(
    requestBody: Array<IListagemDeCustosPrevisto>
) {
    return Controller(AtualizacaoDeCustoPrevistoService(requestBody));
}

export async function RemocaoDeCustosPrevistoController(ID: number) {
    return Controller(RemocaoDeCustosPrevistoService(ID));
}
